import axios from 'axios'

import { MessageBox, Message } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 解决get缓存的问题
    if (config.method == 'get') {
      config.params = {
          _t: Date.parse(new Date()),
          ...config.params
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.config.needHeaders) {
      return {
        data: response.data,
        headers: response.headers
      }
    } else {
      // if the custom code is not 20000, it is judged as an error.
      if (response.status !== 200) {
        if (res.code === 401) {
          MessageBox.alert('账号登录信息过期', '重新登录', {
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              const redirectUrl = store.getters.redirectUrl
              store.dispatch('user/logout', 401)
              if (redirectUrl) {
                window.location.href = redirectUrl
              }
            }
          })
        } else {
          Message.error('服务器数据获取失败，请刷新重试！')
        }
  
        return Promise.reject(res)
      } else {
        return res
      }
    }
  },
  error => {
    Message.error('服务器数据获取失败，请刷新重试！')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js